module.exports = __webpack_public_path__ + "static/media/fazendinha.00fa5516.svg";